import { Analytics } from '@cobliteam/analytics';
import { useDashboard } from '@cobliteam/dashboard/src/providers/DashboardProvider';
import { DatadogTrack } from '@cobliteam/datadog-rum';
import { useGetUnreadNotificationsAmount } from '@cobliteam/hooks/src/useEntity/useAlerts';
import { useTranslation } from '@cobliteam/i18n';
import { Button, DropdownMenu, Tooltip } from '@cobliteam/ui/components';
import Placeholder from '@cobliteam/ui/components/Placeholder';
import Icon from '@cobliteam/ui/icons';
import { endOfDay, startOfDay } from '@cobliteam/utils/date';
import { usePrevious } from 'ahooks';
import { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';
import TriggerNotificationsList from './TriggerNotificationsList';

const today = new Date();
const limitDay = new Date(new Date().setDate(today.getDate() - 6));

const NotificationsButton = () => {
  const { t } = useTranslation('app-header');
  const location = useLocation();
  const { runtimeFlags } = useDashboard();

  const prevLocation = usePrevious(location);

  const [open, setOpen] = useState(false);

  const startOfDayISO = startOfDay(limitDay).toISOString();
  const endOfDayISO = endOfDay(today).toISOString();
  const { data: unreadAmount, refetch } = useGetUnreadNotificationsAmount(startOfDayISO, endOfDayISO);
  const amountLabel = unreadAmount && unreadAmount < 10 ? unreadAmount.toString() : '9+';

  useEffect(() => {
    if (location !== prevLocation) {
      setOpen(false);
    }
  }, [location, prevLocation]);

  if (runtimeFlags.noValidGroupOrVehicles) return null;

  return (
    <DropdownMenu
      open={open}
      onOpenChange={(isOpen) => {
        if (isOpen) Analytics.track('NavBar - Notification - Open');

        setOpen(isOpen);
      }}
    >
      <Tooltip content={t('notifications.tooltip')} asChild>
        <DropdownMenu.Trigger asChild>
          <div className='relative'>
            <Button data-testid='app-header-notifications-button' variant='outlined' color='default' size='sm' icon={<Icon name='bell' />} />
            {unreadAmount ? <div className='-right-2 -top-1 absolute rounded-full bg-danger px-[5px] text-[10px] text-white'>{amountLabel}</div> : null}
          </div>
        </DropdownMenu.Trigger>
      </Tooltip>
      <DropdownMenu.Content className='w-[400px] p-0' portal>
        <ErrorBoundary
          fallback={<Placeholder icon='circle-x' text='Houve um erro ao carregar as notificações' />}
          onError={(error, errorInfo) => {
            DatadogTrack.error(error, {
              component: 'NotificationsButton',
              section: 'AppHeader',
              errorInfo,
            });
          }}
        >
          <TriggerNotificationsList unreadNotifications={unreadAmount} onMarkAllAsRead={() => refetch()} />
        </ErrorBoundary>
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default NotificationsButton;
